import { render } from "./dash.svg?vue&type=template&id=0cf614e3?inline"
const script = {}
script.render = render

export default script